import React from 'react';
import '../styles/Terms.css';

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service</h1>
      <h2>Acceptance of Terms</h2>
      <p>By accessing our website, you agree to these terms of service.</p>
      
      <h2>Use of Service</h2>
      <p>You agree to use our service in accordance with all applicable laws.</p>
    </div>
  );
};

export default Terms;
